import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CronBuilder } from './CronBuilder';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  workflowId: string;
  initialCron: string;
  timezone: string;
  onSave: (cron: string) => void;
  isSaving: boolean;
  cronError?: string | null;
}

export function CronEditDialog({
  open,
  onOpenChange,
  workflowId,
  initialCron,
  timezone,
  onSave,
  isSaving,
  cronError,
}: Props) {
  const [cron, setCron] = useState(initialCron);

  // Re-seed from prop when dialog opens
  useEffect(() => {
    if (open) {
      setCron(initialCron);
    }
  }, [open, initialCron]);

  const handleSave = () => {
    onSave(cron);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Edit Schedule — {workflowId}</DialogTitle>
        </DialogHeader>

        <div className="py-2">
          <CronBuilder value={cron} timezone={timezone} onChange={setCron} />
          {cronError && (
            <p className="text-destructive text-sm mt-2">{cronError}</p>
          )}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isSaving}>
            Cancel
          </Button>
          <Button onClick={handleSave} disabled={isSaving}>
            {isSaving ? 'Saving…' : 'Save'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
